import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default function ClientSnapshotGraph1(props) {
  const DonutClient = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 150,
      width: 150,
      plotAreaWidth: 200,
      plotAreaHeight: 150,
    },
    title: {
      text: null,
      align: "center",
      verticalAlign: "middle",
      y: 20, // for title top margin
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.percentage:.1f}%</b>`,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false, // to hide labels
          style: {
            fontWeight: "bold",
            color: "white",
          },
        },
      },
    },
    series: [
      {
        name: props.title,
        type: "pie",
        innerSize: "70%",
        data: [
          { name: props.subTitle1, y: props.tradedClient },
          { name: props.subTitle2, y: props.tradedClientWmargin },
          { name: props.subTitle3, y: props.tradedClientWOmargin },

          //   { name: props.titles[1], y: props.graphActive },
          //   { name: props.titles[2], y: props.graphInactive },
        ],
      },
    ],
    colors: ["#FF86B1", "#61CFF2", "#D3D3D3"],
  };
  return <HighchartsReact highcharts={Highcharts} options={DonutClient} />;
}
